/**
 * Frases PT→EN pro Word Builder (Sentence Scramble).
 * Ordenadas do mais simples (A1) pro mais complexo (B1+).
 */

export type SentencePair = {
  pt: string;
  en: string;
  /** 1 = A1 básico, 2 = A2 médio, 3 = B1+ avançado */
  level: 1 | 2 | 3;
};

export const SENTENCES: SentencePair[] = [
  // --- A1 ---
  { pt: 'Eu sou feliz.', en: 'I am happy', level: 1 },
  { pt: 'Você é meu amigo.', en: 'You are my friend', level: 1 },
  { pt: 'Ela tem um gato.', en: 'She has a cat', level: 1 },
  { pt: 'Nós gostamos de pizza.', en: 'We like pizza', level: 1 },
  { pt: 'O céu é azul.', en: 'The sky is blue', level: 1 },
  { pt: 'Ele come pão.', en: 'He eats bread', level: 1 },
  { pt: 'Meu nome é Ana.', en: 'My name is Ana', level: 1 },
  { pt: 'O cachorro é grande.', en: 'The dog is big', level: 1 },
  { pt: 'Eu tenho um carro.', en: 'I have a car', level: 1 },
  { pt: 'Ela é minha irmã.', en: 'She is my sister', level: 1 },
  { pt: 'Nós somos estudantes.', en: 'We are students', level: 1 },
  { pt: 'O livro está na mesa.', en: 'The book is on the table', level: 1 },
  { pt: 'Eu gosto de música.', en: 'I like music', level: 1 },
  { pt: 'Ele mora em Londres.', en: 'He lives in London', level: 1 },
  { pt: 'Você fala inglês?', en: 'Do you speak English', level: 1 },

  // --- A2 ---
  { pt: 'Eu estudei inglês ontem.', en: 'I studied English yesterday', level: 2 },
  { pt: 'Ela está bebendo café.', en: 'She is drinking coffee', level: 2 },
  { pt: 'Nós vamos ao cinema amanhã.', en: 'We are going to the cinema tomorrow', level: 2 },
  { pt: 'Você pode me ajudar?', en: 'Can you help me', level: 2 },
  { pt: 'Ele não gosta de café.', en: 'He does not like coffee', level: 2 },
  { pt: 'Minha casa é maior que a sua.', en: 'My house is bigger than yours', level: 2 },
  { pt: 'Eu quero uma pizza grande.', en: 'I want a big pizza', level: 2 },
  { pt: 'Ela acorda cedo todos os dias.', en: 'She wakes up early every day', level: 2 },
  { pt: 'Onde você mora?', en: 'Where do you live', level: 2 },
  { pt: 'Quantos anos você tem?', en: 'How old are you', level: 2 },
  { pt: 'Eu preciso de ajuda agora.', en: 'I need help now', level: 2 },
  { pt: 'Ele está assistindo televisão.', en: 'He is watching television', level: 2 },
  { pt: 'Você comeu o bolo?', en: 'Did you eat the cake', level: 2 },
  { pt: 'Nós moramos em uma cidade pequena.', en: 'We live in a small city', level: 2 },
  { pt: 'Ela escreveu uma carta para o amigo.', en: 'She wrote a letter to the friend', level: 2 },

  // --- B1+ ---
  { pt: 'Se chover, eu ficarei em casa.', en: 'If it rains I will stay home', level: 3 },
  { pt: 'Eu moro aqui há dois anos.', en: 'I have lived here for two years', level: 3 },
  { pt: 'Você deveria dormir mais cedo.', en: 'You should sleep earlier', level: 3 },
  { pt: 'Eu estava lendo quando ele chegou.', en: 'I was reading when he arrived', level: 3 },
  { pt: 'Ela teria vindo se soubesse.', en: 'She would have come if she knew', level: 3 },
  { pt: 'Eu gostaria de viajar pelo mundo.', en: 'I would like to travel around the world', level: 3 },
  { pt: 'Eles já terminaram o projeto.', en: 'They have already finished the project', level: 3 },
  { pt: 'Se eu fosse você, eu aceitaria.', en: 'If I were you I would accept', level: 3 },
  { pt: 'O filme que assistimos foi incrível.', en: 'The movie we watched was amazing', level: 3 },
  { pt: 'Ela me perguntou se eu estava bem.', en: 'She asked me if I was okay', level: 3 },
];
